export default {"src":"/_next/static/media/company4.d3ea4b7f.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};